module.exports = __webpack_public_path__ + "static/img/ls9.291942e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/ls9.png
// module id = o8w8
// module chunks = 12